const QX7Rule = {
    enabled: false,
    raw: null,
    enabledBlockPattern: [
        'Stock Polo',
        'Stock Short',
        'Stock Pant',
        'Stock Sideline Quarter Zip',
        'Crossover Jersey',
        'Stock NL6010',
        '2023 Top Next Level 6010 Triblend',
        'Lite',
        'Pro',
        'Sock'
    ],
    enabledCategories: [
        "Stock Uniforms (Apparel)",
        "Basketball"
    ],
    // Modules
    BodyPart: null,
    Application: null,
    Fabrics: null,
    Assets: null,
    ModifierLabel: null,
    // Application Properties
    appLocations: [],
    appBrandLogoLocations: [],
    // Material Properties
    materialColorGroups: [],
    materialColorSets: [],
    materialFabricGroups: [],
    // Assets
    colors: [],
    fonts: [],
    fabrics: [],
    accents: [],

    defaultFabric: null,
    activeBodyGroup: null,

    connectModules: function() {
        this.BodyPart = new BodyPart;
        this.Application = new Application;
        this.Fabrics = new Fabrics;
        this.Assets = new Assets;
        this.ModifierLabel = new ModifierLabel;
    },

    isEnabledOnBlockPattern(block_pattern) {
        return this.enabledBlockPattern.includes(block_pattern);
    },

    isEnabledOnCategory(category) {
        return this.enabledCategories.includes(category);
    },

    initialize(rule) {
        if (!this.isEnabledOnBlockPattern(ub.config.blockPattern) || !this.isEnabledOnCategory(ub.config.sport)) return;
        if (_.isEmpty(rule)) return;

        console.info("⚙️QX7 rule is enabled for this item.⚙️");
        this.connectModules();

        this.raw = rule;
        this.enabled = true;
        // Assets
        this.colors = this.Assets.transformColors(rule.colors);
        this.fonts = rule.fonts;
        this.fabrics = this.Assets.transformFabrics(rule.fabrics);
        this.accents = JSON.parse(rule.accents);

        // Applications
        this.appLocations = this.Application.getAppLocations(rule.application_locations);
        this.appBrandLogoLocations = this.Application.getBrandLogoAppLocations(rule.brand_logo_application_locations);
        
        // Materials
        this.materialColorGroups = this.BodyPart.getColorGroups(rule.body_part_color_groups);
        this.materialColorSets = this.BodyPart.getColorSets(rule.color_set_data);
        this.materialFabricGroups = this.BodyPart.getFabricGroups(rule.body_part_fabric_groups);

        // Get Default Fabrics
        this.defaultFabric = this.Fabrics.getDefaultFabricCode();

        // Process Fonts
        this.Assets.processFonts(rule.fonts, (data) => {
            ub.data.fonts = data.fonts;
            ub.data.fonts_settings = data.fontSettings;

            // After Process
            if (ub.data.fonts.length > 0) {
                console.log(' ');
                ub.utilities.info("Fonts: ");
                ub.utilities.info(data.fonts.length + " fonts loaded for " + ub.config.brand.toTitleCase());
                ub.utilities.info(ub.config.gender.toTitleCase() + ' / ' + ub.config.sport + ' / ' + ub.config.blockPattern + ' / ' + ub.config.option);
    
                ub.displayDoneAt( ub.data.fonts[0].name + ' preloaded.');
    
                WebFont.load({
                    custom: {
                      families: [ub.data.fonts[0].name,]
                    },
                });

                console.log(' ');
            } else {
                ub.utilities.error('No fonts loaded for ' + ub.config.sport + " / " + ub.config.option + " in QX7!");
            }
        })
    }
};